var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{attrs:{"id":"content-title"}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"d-flex align-items-center"},[_c('h3',{staticClass:"mb-0"},[_vm._v("Dashboard")])])])],1),_c('supervisor-dashboard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }